'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Content = require('./Content');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Content).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Content/index.js
// module id = 317
// module chunks = 0